import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Table from './Table.jsx'
import AllVacationsComponent from './AllVacationsComponent.jsx'
import _ from 'lodash'
import 'bootstrap/dist/css/bootstrap.min.css'

class VacationsComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (_.size(this.props.vacations.vacations) > 0 && this.props.vacations.isAdmin) {
      return <div className="container"><Table vacations={this.props.vacations}></Table><br /><AllVacationsComponent currentUserId={this.props.vacations.currentUserId} allUsers={this.props.vacations.allUsers} allUsersVacations={this.props.vacations.allUsersVacations}></AllVacationsComponent></div>
    } else if (_.size(this.props.vacations.vacations) > 0 && !this.props.vacations.isAdmin) {
      return <div className="container"><Table vacations={this.props.vacations}></Table></div>
    } else if (this.props.vacations.isAdmin) {
      return <div className="container"><h4>You do not have any upcoming vacations!</h4><br /><AllVacationsComponent currentUserId={this.props.vacations.currentUserId} allUsers={this.props.vacations.allUsers} allUsersVacations={this.props.vacations.allUsersVacations}></AllVacationsComponent></div>
    } else {
      return <div className="container">You do not have any upcoming vacations!</div>
    }
  }
}

VacationsComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  vacations: PropTypes.object.isRequired,
}

export default VacationsComponent
